import PaymentMethodSelector from './PaymentMethodSelector';
import PaymentList from './PaymentList';
import PaymentTotal from './PaymentTotal';

export interface PaymentItem {
  id: number;
  paymentMethodId: number;
  methodName: string;
  code: string;
  amount: number | '';
  reference?: string;
}

interface Props {
  items: PaymentItem[];
  setItems: React.Dispatch<React.SetStateAction<PaymentItem[]>>;
  balance: number; // 🔥 viene desde PaymentForm
}

const PaymentMethods = ({
  items,
  setItems,
  balance,
}: Props) => {
  const addPayment = (method: {
    id: number;
    name: string;
    code: string;
  }) => {
    setItems((prev) => [
      ...prev,
      {
        id: Date.now(),
        paymentMethodId: method.id,
        methodName: method.name,
        code: method.code,
        amount: '', // 🔥 permite borrar el input sin problema
        reference: '',
      },
    ]);
  };

  const updateItem = (
    id: number,
    updated: Partial<PaymentItem>
  ) => {
    setItems((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, ...updated }
          : item
      )
    );
  };

  const removeItem = (id: number) => {
    setItems((prev) =>
      prev.filter((item) => item.id !== id)
    );
  };

  // 🔥 total ingresado
  const total = items.reduce(
    (sum, item) => sum + (Number(item.amount) || 0),
    0
  );

  return (
    <div className="px-6 py-5">
      {/* 🔹 Header */}
      <div className="mb-5">
        <h3 className="font-medium text-black dark:text-white">
          Métodos de pago
        </h3>

        <p className="text-sm text-gray-500">
          Agrega uno o varios métodos de pago
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-[320px_1fr]">
        {/* 🔹 IZQUIERDA: selector + resumen */}
        <div className="space-y-4">
          <PaymentMethodSelector
            onAdd={addPayment}
            existingMethodIds={items.map(
              (item) => item.paymentMethodId
            )}
          />

          <PaymentTotal
            total={total}
            balance={balance}
          />
        </div>

        {/* 🔹 DERECHA: tabla de métodos agregados */}
        <div className="overflow-hidden rounded-xl border border-stroke dark:border-strokedark">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-2 dark:bg-boxdark-2">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-body dark:text-bodydark2">
                    Método
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-body dark:text-bodydark2">
                    Monto
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-body dark:text-bodydark2">
                    Referencia
                  </th>
                  <th className="px-4 py-3" />
                </tr>
              </thead>

              <PaymentList
                items={items}
                onUpdate={updateItem}
                onRemove={removeItem}
              />
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethods;